import { useTranslation } from "react-i18next";
import * as it from "@/lib/site";
import * as en from "@/lib/site.en";

const BUNDLES = { it, en };

// Restituisce il modulo di contenuti (named exports) per la lingua attiva.
// Uso: const { STOCKINGS, CONTACT, COPY } = useContent();
export const useContent = () => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "it").split("-")[0];
  return BUNDLES[lang] || BUNDLES.it;
};

export default useContent;
